<template>
  <b-container fluid>
    <b-row style="padding-top: 2em;">
      <b-col>
        <h2>About Global Leadership Alliance</h2>
          <p>GLA is a consulting firm specializing in the development and implementation of Collaborative Dispute Mitigation (CDM) systems for agencies, organizations, and construction projects. We offer customized programs in Construction Project Facilitation, Construction Partnering, Facilitated Dispute resolution (FDR), mediation, strategic planning, executive coaching, and leadership development.</p>
          <p>Since 2001, our certified neutral facilitators have worked on hundreds of projects in many countries, with a total value over more than $30 Billion. GLA is called upon by organizations around the world seeking superior results, aiming to go above and beyond specification requirements. Our clients are motivated to break through barriers, overcome challenges and render exemplary project outcomes.</p>

        <h2>Contact</h2>
            770 L Street, Suite 950
          <br>Sacramento, California, 95814
          <br>P: +1 916 - 374 - 0455
          <br>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Home",
  mounted() {
    if (!this.authenticated) {
      this.$router.push({ name: 'Login' });
    } else {
      this.defaultRedirect();
    }
  }
};
</script>
<style scoped>
</style>
